<template>
  <div class="">
    <cooperators-edit> </cooperators-edit>
  </div>
</template>

<script>
import CooperatorsEdit from "@/components/profile/cooperators/edit.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
    ...mapActions("breadcrumbs", { removeBCS: "removeBreadcrumbs" }),
    ...mapGetters("breadcrumbs", { loadBCS: "loadBreadcrumbs" }),
  },
  components: {
    CooperatorsEdit,
  },
  beforeMount() {
    let bcs = this.loadBCS();
    if (this.$route.query.fromShortcut) {
      bcs.push({
        text: "Modifica Collaborazione Orizzontale",
        path: "brokers.edit1",
        level: 3,
      });
      bcs.forEach((element) => {
        this.notifyQueue({
          text: element.text,
          path: element.path,
          tab: element.tab,
          level: element.level,
          disabled: element.disabled,
        });
      });
      // this.$router.replace({ query: null });
    } else {
      this.notifyQueue({
        text: "Modifica Collaborazione Orizzontale",
        path: "brokers.edit",
        level: 3,
      });
    }
  },
};
</script>
